import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";

export type TriggerUnzipRequest = {
	type?: "csv" | "file"
	triggerFilters?: string[]
}

export const triggerUnzip = createAppAsyncThunk<void, TriggerUnzipRequest>(
	"formStep/triggerUnzip",
	async ({ type, triggerFilters }, { getState, extra, dispatch, rejectWithValue }) => {
		try {
			const { selectedEtlImportUuid } = getState().etlData;
			if (!selectedEtlImportUuid) return;

			if (!type || type === "csv") {
				await extra.etlClient.trigger(EtlApiTarget.UNZIP_CSV_API, selectedEtlImportUuid, { triggerFilters })
				dispatch(postToast({ message: "Le désarchivage des fichiers CSV va commencer", type: ToastType.INFO }))
			}

			if (!type || type === "file") {
				await extra.etlClient.trigger(EtlApiTarget.UNZIP_FILE_API, selectedEtlImportUuid, { triggerFilters })
				dispatch(postToast({ message: "Le désarchivage des fichiers va commencer", type: ToastType.INFO }))
			}

		} catch (error) {
			dispatch(displayApiErrorToast(error.response))
			throw rejectWithValue(error.response.data.message);
		}
	},
	{
		condition: (_, { getState }) => {
			if (getState().formStep.unzipRunning) return false;
		}
	}
);
